import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { BusinessLoanScreen, TitleSection } from "../../components";

export default function BusinessLoan() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Business Loan", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/business-loan-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <BusinessLoanScreen />
    </DefaultLayout>
  );
}
